<template>

    <server-table
        ref="servertable"
        :data-url="dataUrl"
        :data-columns="dataColumns"
        :items-per-page="itemsPerPage"
        @after-column-active-toggle="onAfterColumnActiveToggle"
        @after-column-resize="onAfterColumnResize"
        @double-clicked-row="onDoubleClick"
    ></server-table>

</template>

<script>

    import axios from 'axios';
    import ServerTable from '../../Libraries/ServerTable/ServerTable';
    import Hub from "../../Hub";

    export default {

        components: {
            ServerTable,
        },

        destroyed() {
            Hub.$off('contact-added-to-project', this.reloadServerTable);
        },

        methods: {
            onAfterColumnActiveToggle(column) {
                this.patchRequest(column, 'active');
            },
            onAfterColumnResize(column) {
                this.patchRequest(column, 'resize');
            },
            onDoubleClick(row){
                // Check double click callback
                if (null === this.doubleClickCb) {
                    if (row.itemUri) {
                        this.$router.push(row.itemUri);
                    }
                } else {
                    this.doubleClickCb(row);
                }
            },

            patchRequest(column, action){
                axios.patch(this.preferenceUrl,{
                    name: column.id,
                    value: column.width,
                    action: action
                }).then();
            },

            reloadServerTable() {
                this.$refs.servertable.data = [];
                this.$refs.servertable.fetchData(true);
            },
        },

        mounted() {
            // Listen to specific event.
            this.$nextTick(function () {
                Hub.$on('contact-added-to-project', this.reloadServerTable);
            }.bind(this));
        },

        name:"ProjectContactsServerTable",

        props: {
            doubleClickCb: {
                default:null,
            },
            dataUrl:{ required:true },
            dataColumns: {
                required:true,
                type:String,
            },
            itemsPerPage: {
                type:Number,
                default:100,
            },
            preferenceUrl: {
                required:true,
                type:String,
            },
        },

    }

</script>
